import { createFileRoute, Outlet } from '@tanstack/react-router'
import { paymentQueryOptions } from '../../../../features/purchasing/queries'

export const Route = createFileRoute('/_app/supplier-payments/$paymentId')({
  staticData: { crumb: 'supplierPayment' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(paymentQueryOptions(params.paymentId)),
  component: Outlet,
})
